module.exports = __webpack_public_path__ + "img/navbar-logo.2c061749.svg";